/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIContactAutocompleteSuggestion } from './APIContactAutocompleteSuggestion';
import {
    APIContactAutocompleteSuggestionFromJSON,
    APIContactAutocompleteSuggestionFromJSONTyped,
    APIContactAutocompleteSuggestionToJSON,
} from './APIContactAutocompleteSuggestion';

/**
 * 
 * @export
 * @interface APIContactAutocompleteResponse
 */
export interface APIContactAutocompleteResponse {
    /**
     * 
     * @type {Array<APIContactAutocompleteSuggestion>}
     * @memberof APIContactAutocompleteResponse
     */
    suggestions: Array<APIContactAutocompleteSuggestion>;
    /**
     * 
     * @type {number}
     * @memberof APIContactAutocompleteResponse
     */
    total: number;
}

/**
 * Check if a given object implements the APIContactAutocompleteResponse interface.
 */
export function instanceOfAPIContactAutocompleteResponse(value: object): value is APIContactAutocompleteResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function APIContactAutocompleteResponseFromJSON(json: any): APIContactAutocompleteResponse {
    return APIContactAutocompleteResponseFromJSONTyped(json, false);
}

export function APIContactAutocompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContactAutocompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(APIContactAutocompleteSuggestionFromJSON)),
        'total': json['total'],
    };
}

export function APIContactAutocompleteResponseToJSON(value?: APIContactAutocompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map(APIContactAutocompleteSuggestionToJSON)),
        'total': value['total'],
    };
}

